var _style, _rect, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1513.7 788.8",
    style: {
      enableBackground: "new 0 0 1513.7 788.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st000{fill:none;}\r\n\t.st100{fill:#323B3F;}\r\n\t.st200{font-family: \"BTekUp-Font\", Arial, Helvetica, sans-serif;}\r\n\t.st300{font-size:36px;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 453.2,
    y: 277.2,
    className: "st000",
    width: 775.4,
    height: 381.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 593.4741 296.2286)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st200 st300"
  }, "providing our clients with solutions that are"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.1,
    y: 44.4,
    className: "st100 st200 st300"
  }, "100% optimizable, scalable and measurable to"), /*#__PURE__*/React.createElement("tspan", {
    x: -63.8,
    y: 88.8,
    className: "st100 st200 st300"
  }, "meet their technological needs. Our team of experts"), /*#__PURE__*/React.createElement("tspan", {
    x: -77.2,
    y: 133.2,
    className: "st100 st200 st300"
  }, "in innovation and digital transformation is dedicated"), /*#__PURE__*/React.createElement("tspan", {
    x: -54.1,
    y: 177.6,
    className: "st100 st200 st300"
  }, "to ensuring that your brand achieves a distinctive"), /*#__PURE__*/React.createElement("tspan", {
    x: -41.5,
    y: 222,
    className: "st100 st200 st300"
  }, "online presence through the selection of digital"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.1,
    y: 266.4,
    className: "st100 st200 st300"
  }, "tools and the precise application of"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.6,
    y: 310.8,
    className: "st100 st200 st300"
  }, "innovation strategies."))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextD);
export default __webpack_public_path__ + "static/media/textD.a33e1db8.svg";
export { ForwardRef as ReactComponent };